// require("../../../public/translations/js/" + lang + ".js");
// window.Translator = Translator;
window.Translator = Translator;

// export default Translator;
